export default require('./EpisodeSubtitle').default
